let utils = require( './utils' );

let sos_invitation = (function( $ ) {

	let $invitation;

	let _init = function() {
		$invitation = $( '.sos-invitation' );

		if ( $invitation.length > 0 ) {
			$invitation.find( 'a.accept-invite' ).on( 'click', _accept_invite );
			$invitation.find( 'a.decline-invite' ).on( 'click', _decline_invite );
		}
	};

	let _accept_invite = function( e ) {
		e.preventDefault();

		let data = {
			action: 'crate_accept_sos_invite',
			nonce: ScriptData.crate_accept_sos_invite_nonce,
			presentation: $( this ).data( 'presentation' ),
		};

		utils.show_spinner();

		$.post( ScriptData.ajaxurl, data, _invite_action_response );
	};

	let _decline_invite = function(e) {
		e.preventDefault();

		let data = {
			action: 'crate_decline_sos_invite',
			nonce: ScriptData.crate_decline_sos_invite_nonce,
			presentation: $( this ).data( 'presentation' ),
		};

		utils.show_spinner();

		$.post( ScriptData.ajaxurl, data, _invite_action_response );
	};

	let _invite_action_response = function( response ) {
		window.location.reload();
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = sos_invitation;